import { Controller } from "./helpers/controller.js";
import {Flickity} from "./utils/loadFlickity";

class BookingSlot {
    public startTime: Date = new Date();
    public endTime: Date = new Date();
}

class BookingSlotDay {
    public availableDate: Date = new Date();
    public slotCount: number = 0;
}

class BookingSlotsData {
    public bookingSlotDays: BookingSlotDay[] = [];
    public bookingSlots: BookingSlot[] = [];
}

export class MemberSignupSlotSelection extends Controller {

    private bookingSlots: BookingSlot[] = [];
    private bookingSlotDays: BookingSlotDay[] = [];
    private bookingSlotsCurrentData: BookingSlotsData = new BookingSlotsData;
    private daySlot: JQuery = $('[name="dateChoice"]');
    private timeSelection: JQuery = $("[data-switch-slot-time]");
    private slotSelectedMessage: JQuery = $("[data-switch-selected-slot]");
    private noSlotMessage: JQuery = $("[data-switch-no-slot]");
    private noGoNext: JQuery = $("[data-switch-form-navigation-step-2]");
    private goNext: JQuery = $("[data-switch-form-navigation-step-2-complete]");
    private noSlotsAvailableMessageAM = "<p class='formInfo''>No slots available at this time, please check PM</p>";
    private noSlotsAvailableMessagePM = "<p class='formInfo''>No slots available please check AM or another date</p>";
    private formChooseSlot = $("[data-switch-slot-pick-form]");


    private dateCarousel: any;

    private correlationId: JQuery = $('#CorrelationId');
    private centreId: JQuery = $('#CentreId');
    private variantSku: JQuery = $('#VariantSku');
    private tuitionYear: JQuery = $('#TuitionYear');
    private desiredSchools: JQuery = $('#DesiredSchools');
    private sessionId: JQuery = $('#SelectedSessionId');
    private productName: JQuery = $('#ProductDisplayName');
    private flickity: Flickity = new Flickity();

    constructor(element: HTMLElement) {
        super(element);

        this.flickity.loadScript(() => 0);
        
        this.GetAvailableSlotsData(0);

        this.daySlot.on('click', (e) => {
            this.SelectDay();
        });
    }

    SlideChangedListener = (event: any, index: number) => {
        this.HandleSlideChanged();
    }

    HandleSlideChanged = () => {

        var flkty = this.dateCarousel.data('flickity');

        // If we are now on the loader (i.e. last slide) then we need more data
        if (flkty.selectedIndex === flkty.slides.length - 1) {
            // Get the latest data
            this.GetAvailableSlotsData(flkty.selectedIndex * 6);
        }
    }

    RepaintAvailableDays = () => {
        
        // Create the new 'Slide' for latest data
        var additionalCell = `<div class="carousel-cell">`;
        this.bookingSlotDays.forEach(function (value: BookingSlotDay) {
            let thisDate = new Date(value.availableDate);
            let stringDate = `${thisDate.getFullYear()}-${('0' + (thisDate.getMonth() + 1)).slice(-2) }-${('0' + thisDate.getDate()).slice(-2)}`;
            additionalCell +=
                `
                    <label class="radioBlock ${value.slotCount === 0 ? 'unavailable' : ''}" for="${thisDate.toDateString()}" >
                    <input type="radio" id="${thisDate.toDateString()}" name="dateChoice" value="${stringDate}">
                        <span class="radioLabel" >${thisDate.toLocaleString('en-GB', { weekday: 'short' })}<span>${thisDate.toLocaleString('en-GB', { day: '2-digit' })} ${thisDate.toLocaleString('en-GB', { month: 'short' })}</span></span >
                    </label>                
                `
        });
        additionalCell += `</div>`;

        this.CreateNewSlide(additionalCell);
    }

    CreateNewSlide = (content: string) => {
        // Get the flickity carousel if we dont already have it
        if (this.dateCarousel == undefined) {
            this.dateCarousel = $('.dateCarousel').flickity({
                pageDots: false
            });
        }

        // Turn off the listener while we push this in
        this.dateCarousel.off('change.flickity', this.SlideChangedListener);

        // Place the slide before the final slide (loader)
        var flkty = this.dateCarousel.data('flickity');
        var newIndex = Math.max(flkty.slides.length - 1, 0);
        this.dateCarousel.flickity('insert', $(content), newIndex);

        // Make the new slide the viewing slide
        this.dateCarousel.flickity('selectCell', newIndex, false, true);

        // Turn back on the listener 
        this.dateCarousel.on('change.flickity', this.SlideChangedListener);

        // Add the onclicks for day selection
        $('[name="dateChoice"]').on('click', (e) => {
            this.SelectDay();
        });
    }

    GetAvailableSlotsData = (skipDays: number) => {
        if (this.centreId.val() == "0") {
            // Due to online not having any availability for the 1st six days
            // we are now shifting all its requests on by 6 days, so in effect it just
            // skips the first card.
            skipDays = skipDays + 6;
        }

        let dataUrl = `/api/membership/member-slots?correlationId=${this.correlationId.val()}&centreId=${this.centreId.val()}&sku=${this.variantSku.val()}&productSlotSessionId=${this.sessionId.val()}&productName=${this.productName.val()}&skipDays=${skipDays}&tuitionYear=${this.tuitionYear.val()}&desiredSchools=${this.desiredSchools.val()}`;
        $.getJSON(dataUrl, (data) => {
            this.bookingSlotsCurrentData = data;
            this.bookingSlots = this.bookingSlots.concat(this.bookingSlotsCurrentData.bookingSlots);
            this.bookingSlotDays = this.bookingSlotsCurrentData.bookingSlotDays;
            this.flickity.loadScript(() => {
                this.RepaintAvailableDays();
                this.SelectFirstDayAndMeridiem();
            });
        }).fail( (jqXHR) => {
            console.log(jqXHR.responseText);
            this.HandleGetSlotDataIssue();
        });
    }

    HandleGetSlotDataIssue = () => {
        $('#sessionPicker').hide();
        $('#noSessionData').show();
        this.ResetDay();
        this.timeSelection.hide();

    }

    SelectFirstDayAndMeridiem = () => {
        // pre-select the first day and am/pm with the first slot
        if (this.bookingSlots.length < 1) {
            return;
        }

        // only if a day isn't already selected
        if ($("input[name='dateChoice']:checked").length > 0) {
            return;
        }

        let firstDay = this.bookingSlots[0].startTime.toString().split('T')[0];
        ($("input[name='dateChoice'][value='" + firstDay + "']")[0] as HTMLInputElement).checked = true;
        this.SelectDay();

        if (parseInt(this.bookingSlots[0].startTime.toString().split('T')[1].substring(0, 2)) >= 12) {
            $("a[href='#pm']")[0].click();
        }
    }

    SelectDay = () => {
        let selectedDay = $("input[name='dateChoice']:checked").val();
        var selectedDayParts = selectedDay.split('-');
        var selectedDate = new Date(selectedDayParts[0], selectedDayParts[1] - 1, selectedDayParts[2]);
        let selectedDateStartTime = new Date(selectedDate).getTime();
        let selectedDateEndTime = selectedDateStartTime + (60 * 60 * 24 * 1000) - 1;
        let results = this.bookingSlots.filter(d => {
            var bookingSlotTime = new Date(d.startTime).getTime();
            return (selectedDateStartTime < bookingSlotTime && bookingSlotTime < selectedDateEndTime);
        });
        this.RepaintAvailableTimeSlots(results);
    }

    RepaintAvailableTimeSlots = (slots: BookingSlot[]) => {
        let pmSlotsHtml = "";
        let amSlotsHtml = "";
        for (let index = 0; index < slots.length; index++) {
            let slot = slots[index];
            let slotTime = new Date(slot.startTime).toLocaleTimeString("en-GB", { timeZone: "Europe/London", hour: "2-digit", minute: "2-digit" })
            let slotTimeEnd = new Date(slot.endTime).toLocaleTimeString("en-GB", { timeZone: "Europe/London", hour: "2-digit", minute: "2-digit" })
            let slotTimeString = slotTime.replace(':', '-');
            let slotHtml = `
                <label class="radioTimeBlock" for="time${slotTimeString}">
                    <input type="radio" id="time${slotTimeString}" name="timeChoice" value="${slotTime}" data-end-time="${slotTimeEnd}" data-slot-start=${slot.startTime} data-slot-end=${slot.endTime}>
                    <span class="radioTimeLabel">${slotTime}</span>
                </label>
            `;

            if (new Date(slot.startTime).getHours() > 11) {
                pmSlotsHtml += slotHtml;
            } else {
                amSlotsHtml += slotHtml;
            }
        }

        $('#am').html(amSlotsHtml !== "" ? amSlotsHtml : this.noSlotsAvailableMessageAM);
        $('#pm').html(pmSlotsHtml !== "" ? pmSlotsHtml : this.noSlotsAvailableMessagePM);

        $('[name="timeChoice"]').on('click', (e) => {
            this.SelectTimeSlot();
        });

        this.ResetDay();

        this.timeSelection.show();
    }

    SelectTimeSlot = () => {
        let temp = $("input[name='timeChoice']:checked")
        this.formChooseSlot.find('#selectedSlotStartTime').val($("input[name='timeChoice']:checked").data("slot-start"));
        this.formChooseSlot.find('#selectedSlotEndTime').val($("input[name='timeChoice']:checked").data("slot-end"));

        this.noSlotMessage.hide();
        this.RepaintSelectedMessage();
        this.slotSelectedMessage.show();
        this.noGoNext.hide();
        this.goNext.show();

    }

    RepaintSelectedMessage = () => {
        let selectedDay = $("input[name='dateChoice']:checked").val();

        var selectedDayParts = selectedDay.split('-');
        var selectedDate = new Date(selectedDayParts[0], selectedDayParts[1] - 1, selectedDayParts[2]);

        let selectedTime = $("input[name='timeChoice']:checked").val();
        let selectedTimeEnd = $("input[name='timeChoice']:checked").data("end-time");
        let message = `${selectedDate.toLocaleDateString("en-GB", { timeZone: "Europe/London", weekday: 'long' })}, ${selectedDate.toLocaleDateString("en-GB", { timeZone: "Europe/London", day: 'numeric' })} ${selectedDate.toLocaleDateString("en-GB", { timeZone: "Europe/London", month: 'short' })}<span>${selectedTime} - ${selectedTimeEnd}</span>`;
        let messageBox = $(".completedItemLarge");
        messageBox.html(message);
    }

    ResetDay = () => {
        this.noSlotMessage.show();
        this.slotSelectedMessage.hide();
        this.noGoNext.show();
        this.goNext.hide();
    }
}


